import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, CardBody, CardHeader, FormGroup, Label, Input, Button, Row, Col, Table } from "reactstrap";
import { MdAdd, MdRemove } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";
import { getTicketSubType, getTicketSubSubType, getTicketType, getTouristType, getTicketPriceDetails, getVisitorSubTypeByType, getVisitorSubSubTypeBySubType } from "../../redux/actions/indexActions";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AdditionalFormFields from "./AdditionalFormFields";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DiscountFields, {
    INITIAL_DISCOUNT,
    validateDiscountFields,
    appendDiscountToForm,
    mapDiscountFromItem,
    getDiscountStatusLabel,
} from "./DiscountFields";

const PriceMaster = ({ ticketSubType, placeId }) => {
    const dispatch = useDispatch();
    const { indexReducer: { ticketBasePrice,servicesPrice,ticketPrices,priceFormDetails,TicketTypeList, TicketSubTypeList, TicketSubSubTypeList, TouristTypeList ,visitorSubTypeListByType,visitorSubSubTypeListBySubType} } = useSelector((state) => state);
    const { auth } = useSelector((state) => state.AuthReducer);
    const [services, setServices] = useState([{ serviceId:"",service_name: "", service_price: "" }]);
    const [errors, setErrors] = useState({});
    const [basePrice, setBasePrice] = useState({id:"",price:""});
    const [formData, setFormData] = useState({
        onlyBasePrice:true,
        onlyTicketTypePrice:false,
        onlyVisitorTypePrice:false,
        basePriceWithTicketTypePrice:false,
        basePriceWithVisitorTypePrice:false,
        basePriceWithTicketAndVisitorPrice:false
    });
    const [isEdit, setIsEdit] = useState({
        ticketSubSubType:false,
        ticketSubType:false,
        ticketType:false,
        visitorSubSubPrice:false,
        visitorSubPrice:false,
        visitorPrice:false,
        basePrice:false,
    });
    const [isVisitor, setIsVisitor] = useState({
        ticketTypeWithVisitor:false,
        ticketSubTypeWithVisitor:false,
        ticketSubSubTypeWithVisitor:false,
    });
    const [ticketTypePrice, setTicketTypePrice] = useState({
        price:"",
        ticketType:"",
        visitorId:"",
        subVisitorId:"",
        subSubVisitorId:"",
    });
    const [ticketSubTypePrice, setTicketSubTypePrice] = useState({
        price:"",
        ticketType:"",
        ticketSubType:"",
        visitorId:"",
        subVisitorId:"",
        subSubVisitorId:"",
    });
    const [ticketSubSubTypePrice, setTicketSubSubTypePrice] = useState({
        price:"",
        ticketType:"",
        ticketSubType:"",
        ticketSubSubType:"",
        visitorId:"",
        subVisitorId:"",
        subSubVisitorId:"",
    });
    const [visitorPrice, setVisitorPrice] = useState({
        visitorId:"",
        visitorPrice:"",
        subVisitorId:"",
        subVisitorPrice:"",
        subSubVisitorId:"",
        subSubVisitorPrice:"",
    });
    const [discountState, setDiscountState] = useState({
        ticketType: { ...INITIAL_DISCOUNT },
        ticketSubType: { ...INITIAL_DISCOUNT },
        ticketSubSubType: { ...INITIAL_DISCOUNT },
        visitorPrice: { ...INITIAL_DISCOUNT },
        subVisitorPrice: { ...INITIAL_DISCOUNT },
        subSubVisitorPrice: { ...INITIAL_DISCOUNT },
    });

    const updateDiscount = (formKey, updates) => {
        setDiscountState((prev) => ({
            ...prev,
            [formKey]: {
                ...prev[formKey],
                ...updates,
            },
        }));
    };

    const resetAllDiscounts = () => {
        setDiscountState({
            ticketType: { ...INITIAL_DISCOUNT },
            ticketSubType: { ...INITIAL_DISCOUNT },
            ticketSubSubType: { ...INITIAL_DISCOUNT },
            visitorPrice: { ...INITIAL_DISCOUNT },
            subVisitorPrice: { ...INITIAL_DISCOUNT },
            subSubVisitorPrice: { ...INITIAL_DISCOUNT },
        });
    };
    useEffect(()=> {
        setServices(
            servicesPrice?.map(({ id, ...rest }) => ({
            serviceId: id,
            ...rest
            }))
        );
        setBasePrice({id:ticketBasePrice?.id,price:ticketBasePrice?.price});

        setFormData({
            onlyBasePrice:priceFormDetails?.onlyBasePrice == 1 ? true : false,
            onlyTicketTypePrice:priceFormDetails?.onlyTicketTypePrice == 1 ? true : false,
            onlyVisitorTypePrice:priceFormDetails?.onlyVisitorTypePrice == 1 ? true : false,
            basePriceWithTicketTypePrice:priceFormDetails?.basePriceWithTicketTypePrice == 1 ? true : false,
            basePriceWithVisitorTypePrice:priceFormDetails?.basePriceWithVisitorTypePrice == 1 ? true : false,
            basePriceWithTicketAndVisitorPrice:priceFormDetails?.basePriceWithTicketAndVisitorPrice == 1 ? true : false
        });
        // setIsVisitor({
        //     ticketTypeWithVisitor:priceFormDetails?.ticketTypeWithVisitor == 1 ? true : false,
        //     ticketSubTypeWithVisitor:priceFormDetails?.ticketSubTypeWithVisitor == 1 ? true : false,
        //     ticketSubSubTypeWithVisitor:priceFormDetails?.ticketSubSubTypeWithVisitor == 1 ? true : false,
        // });

    },[ticketBasePrice,servicesPrice,ticketPrices,priceFormDetails]);

    useEffect(() => {
        dispatch(getTicketType(auth.token, placeId));
        dispatch(getTouristType(auth.token, placeId));
        dispatch(getTicketPriceDetails(auth.token, placeId));
    }, [dispatch, auth.token, placeId]);

    const ticketTypeHandler = (e) => {
        const { name, value } = e.target;
        setTicketTypePrice((prev) => ({ ...prev, [name]: value }));
        if (name === "ticketType") {
            dispatch(getTicketSubType(auth.token, value));
            setTicketSubTypePrice((prev) => ({ ...prev, ticketType: value }));
            setTicketSubSubTypePrice((prev) => ({ ...prev, ticketType: value }));
        }
        if (name === "visitorId" ) {
            dispatch({ type: "RESET_VISITOR_SUB_SUB_TYPE" });
            dispatch(getVisitorSubTypeByType(auth.token, value));
        } else if (name === "subVisitorId" ) {
            dispatch(getVisitorSubSubTypeBySubType(auth.token, value));
        }
    };
    const ticketSubTypeHandler = (e) => {
        const { name, value } = e.target;
        setTicketSubTypePrice((prev) => ({ ...prev, [name]: value }));
        if (name === "ticketSubType") {
            dispatch(getTicketSubSubType(auth.token, value));
            setTicketSubTypePrice((prev) => ({ ...prev, ticketSubType: value }));
            setTicketSubSubTypePrice((prev) => ({ ...prev, ticketSubType: value }));
        }
        if (name === "visitorId" ) {
            dispatch({ type: "RESET_VISITOR_SUB_SUB_TYPE" });
            dispatch(getVisitorSubTypeByType(auth.token, value));
        } else if (name === "subVisitorId") {
            dispatch(getVisitorSubSubTypeBySubType(auth.token, value));
        }

    };
    const ticketSubSubTypeHandler = (e) => {
        const { name, value } = e.target;
        setTicketSubSubTypePrice((prev) => ({ ...prev, [name]: value }));
        if (name === "visitorId" ) {
            dispatch({ type: "RESET_VISITOR_SUB_SUB_TYPE" });
            dispatch(getVisitorSubTypeByType(auth.token, value));
        } else if (name === "subVisitorId") {
            dispatch(getVisitorSubSubTypeBySubType(auth.token, value));
        }

    };
    const visitorHandler = (e) => {
        const { name, value } = e.target;
        setVisitorPrice((prev) => ({ ...prev, [name]: value }));
        if (name === "visitorId" ) {
            dispatch({ type: "RESET_VISITOR_SUB_SUB_TYPE" });
            dispatch(getVisitorSubTypeByType(auth.token, value));
        } else if (name === "subVisitorId" ) {
            dispatch(getVisitorSubSubTypeBySubType(auth.token, value));
        }

    };

    const inputServiceHandler = (e, index) => {
        const { name, value } = e.target;
        const updatedServices = [...services];
        updatedServices[index][name] = value;
        setServices(updatedServices);
    };
    const addService = () => {
        setServices([...services, { serviceId:"",service_name: "", service_price: "" }]);
    };
    const removeService = (index) => {
        setServices(services.filter((_, i) => i !== index));
    };

    const handleServiceDel = (id) => {
        if (window.confirm("Are You Sure You Want To Delete ?")) {
                axios.delete(`/api/admin/v1/service-delete/${id}`, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getTicketPriceDetails(auth.token, placeId));
            }).catch((err) => toast.error("Somthing Went Wrong"));
        }
    };
    const handleTicketPriceDel = (id) => {
        if (window.confirm("Are You Sure You Want To Delete ?")) {
                axios.delete(`/api/admin/v1/ticket-price-delete/${id}`, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getTicketPriceDetails(auth.token, placeId));
            }).catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const setFormDataPayload = (submitType) => {
        const form = new FormData();
        if(submitType === "ticketType"){
            if (ticketTypePrice?.price == "") {
                toast.error("Price is required!");
                return false;
            }
            if (ticketTypePrice?.ticketType == "") {
                toast.error("Ticket Type is required!");
                return false;
            }
            if (!validateDiscountFields(discountState.ticketType, toast)) {
                return false;
            }
            form.append("id", ticketTypePrice?.id);
            form.append("place_id",placeId);
            form.append("ticket_type_id", ticketTypePrice?.ticketType);
            form.append("tourist_type_id", (ticketTypePrice?.visitorId != "") ? ticketTypePrice?.visitorId :"");
            form.append("tourist_sub_type_id", ( ticketTypePrice?.subVisitorId != "") ? ticketTypePrice?.subVisitorId :"");
            form.append("tourist_sub_sub_type_id", (ticketTypePrice?.subSubVisitorId != "") ? ticketTypePrice?.subSubVisitorId : "");
            form.append("formData", JSON.stringify(formData));
            form.append("isVisitor", JSON.stringify(isVisitor));
            // form.append("type", (ticketTypePrice?.subSubVisitorId != "") ? 'ticketTypeWithSubSubVisitor' : (ticketTypePrice?.subVisitorId != "") ? 'ticketTypeWithSubVisitor' :(ticketTypePrice?.visitorId != "") ? 'ticketTypeWithVisitor' : 'ticketType');
            form.append("type", 'ticketType');
            form.append("price", ticketTypePrice?.price);
            appendDiscountToForm(form, discountState.ticketType);
        }else if(submitType === "ticketSubType"){
            if (ticketSubTypePrice?.price == "") {
                toast.error("Price is required!");
                return false;
            }
            if (ticketSubTypePrice?.ticketSubType == "") {
                toast.error("Ticket Sub Type is required!");
                return false;
            }
            if (!validateDiscountFields(discountState.ticketSubType, toast)) {
                return false;
            }
            form.append("id", ticketSubTypePrice?.id);
            form.append("place_id",placeId);
            form.append("ticket_type_id", ticketSubTypePrice?.ticketType);
            form.append("ticket_sub_type_id", ticketSubTypePrice?.ticketSubType);
            form.append("tourist_type_id", (ticketSubTypePrice?.visitorId != "") ? ticketSubTypePrice?.visitorId :"");
            form.append("tourist_sub_type_id", ( ticketSubTypePrice?.subVisitorId != "") ? ticketSubTypePrice?.subVisitorId :"");
            form.append("tourist_sub_sub_type_id", (ticketSubTypePrice?.subSubVisitorId != "") ? ticketSubTypePrice?.subSubVisitorId : "");
            form.append("formData", JSON.stringify(formData));
            form.append("isVisitor", JSON.stringify(isVisitor));
            form.append("type",'ticketSubType');
            form.append("price", ticketSubTypePrice?.price);
            appendDiscountToForm(form, discountState.ticketSubType);
        }else if(submitType === "ticketSubSubType"){
            if (ticketSubSubTypePrice?.price == "") {
                toast.error("Price is required!");
                return false;
            }
            if (ticketSubSubTypePrice?.ticketSubSubType == "") {
                toast.error("Ticket Sub Sub Type is required!");
                return false;
            }
            if (!validateDiscountFields(discountState.ticketSubSubType, toast)) {
                return false;
            }
            form.append("id", ticketSubSubTypePrice?.id);
            form.append("place_id",placeId);
            form.append("ticket_type_id", ticketSubSubTypePrice?.ticketType);
            form.append("ticket_sub_type_id", ticketSubSubTypePrice?.ticketSubType);
            form.append("ticket_sub_sub_type_id", ticketSubSubTypePrice?.ticketSubSubType);
            form.append("tourist_type_id", (ticketSubSubTypePrice?.visitorId != "") ? ticketSubSubTypePrice?.visitorId :"");
            form.append("tourist_sub_type_id", ( ticketSubSubTypePrice?.subVisitorId != "") ? ticketSubSubTypePrice?.subVisitorId :"");
            form.append("tourist_sub_sub_type_id", (ticketSubSubTypePrice?.subSubVisitorId != "") ? ticketSubSubTypePrice?.subSubVisitorId : "");
            form.append("formData", JSON.stringify(formData));
            form.append("isVisitor", JSON.stringify(isVisitor));
            form.append("type",'ticketSubSubType');
            form.append("price", ticketSubSubTypePrice?.price);
            appendDiscountToForm(form, discountState.ticketSubSubType);
        }else if(submitType === "visitorPrice"){
            if (visitorPrice?.visitorPrice == "") {
                toast.error("Price is required!");
                return false;
            }
            if (visitorPrice?.visitorId == "") {
                toast.error("Visitor Type is required!");
                return false;
            }
            if (!validateDiscountFields(discountState.visitorPrice, toast)) {
                return false;
            }
            form.append("formData", JSON.stringify(formData));
            form.append("isVisitor", JSON.stringify(isVisitor));
            form.append("id", visitorPrice?.id);
            form.append("place_id",placeId);
            form.append("tourist_type_id", visitorPrice?.visitorId);
            form.append("type", "visitorPrice");
            form.append("price", visitorPrice?.visitorPrice);
            appendDiscountToForm(form, discountState.visitorPrice);
        }else if(submitType === "subVisitorPrice"){
            if (visitorPrice?.subVisitorPrice == "") {
                toast.error("Price is required!");
                return false;
            }
            if (visitorPrice?.visitorId == "") {
                toast.error("Visitor Type is required!");
                return false;
            }
            if (visitorPrice?.subVisitorId == "") {
                toast.error("Sub Visitor Type is required!");
                return false;
            }
            if (!validateDiscountFields(discountState.subVisitorPrice, toast)) {
                return false;
            }
            form.append("formData", JSON.stringify(formData));
            form.append("isVisitor", JSON.stringify(isVisitor));
            form.append("id", visitorPrice?.id);
            form.append("place_id",placeId);
            form.append("tourist_type_id", visitorPrice?.visitorId);
            form.append("tourist_sub_type_id", visitorPrice?.subVisitorId);
            form.append("type", "subVisitorPrice");
            form.append("price", visitorPrice?.subVisitorPrice);
            appendDiscountToForm(form, discountState.subVisitorPrice);
        }else if(submitType === "subSubVisitorPrice"){
            if (visitorPrice?.subSubVisitorPrice == "") {
                toast.error("Price is required!");
                return false;
            }
            if (visitorPrice?.visitorId == "") {
                toast.error("Visitor Type is required!");
                return false;
            }
            if (visitorPrice?.subVisitorId == "") {
                toast.error("Sub Visitor Type is required!");
                return false;
            }
            if (visitorPrice?.subSubVisitorId == "") {
                toast.error("Sub Sub Visitor Type is required!");
                return false;
            }
            if (!validateDiscountFields(discountState.subSubVisitorPrice, toast)) {
                return false;
            }
            form.append("formData", JSON.stringify(formData));
            form.append("isVisitor", JSON.stringify(isVisitor));
            form.append("id", visitorPrice?.id);
            form.append("place_id",placeId);
            form.append("tourist_type_id", visitorPrice?.visitorId);
            form.append("tourist_sub_type_id", visitorPrice?.subVisitorId);
            form.append("tourist_sub_sub_type_id", visitorPrice?.subSubVisitorId);
            form.append("type", "subSubVisitorPrice");
            form.append("price", visitorPrice?.subSubVisitorPrice);
            appendDiscountToForm(form, discountState.subSubVisitorPrice);
        }else if(submitType === "basePrice"){
            if (basePrice?.price == "") {
                toast.error("Base Price is required!");
                return false;
            }
            form.append("formData", JSON.stringify(formData));
            form.append("isVisitor", JSON.stringify(isVisitor));
            form.append("id", basePrice?.id);
            form.append("place_id",placeId);
            form.append("tourist_category_id","");
            form.append("type", "baseprice");
            form.append("price", basePrice?.price);
        }
        form.append("services", JSON.stringify(services));
        return form;
    }
    const handleSubmit = (submitType) => {
        if (placeId == "" || placeId == "null" || placeId == null || placeId == undefined) {
            toast.error("Category field is required!");
            return false;
        }
        if (basePrice == "") {
            toast.error("Base Price is required!");
            return false;
        }
        const formDataPayload = setFormDataPayload(submitType);
        if(formDataPayload != false){
            axios.post(`/api/admin/v1/addUpdate-ticket-price`, formDataPayload, {
                headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${auth?.token}` },
            }).then((res) => {
                toast.success(res.data?.message);
                dispatch(getTicketPriceDetails(auth.token, placeId));
                setTicketTypePrice({price:"",ticketType:"",visitorId:"",subVisitorId:"",subSubVisitorId:""});
                setTicketSubTypePrice({price:"",ticketSubType:"",visitorId:"",subVisitorId:"",subSubVisitorId:""});
                setTicketSubSubTypePrice({price:"",ticketSubSubType:"",visitorId:"",subVisitorId:"",subSubVisitorId:""});
                setVisitorPrice({visitorId:"",visitorPrice:"",subVisitorId:"",subVisitorPrice:"",subSubVisitorId:"",subSubVisitorPrice:""});
                setIsVisitor({ticketType:false,ticketSubType:false,ticketSubSubType:false});
                setIsEdit({ticketSubSubType:false,ticketSubType:false,ticketType:false,visitorSubSubPrice:false,visitorSubPrice:false,visitorPrice:false,basePrice:false});
                setFormData({onlyBasePrice:false,onlyTicketTypePrice:false,onlyVisitorTypePrice:false,basePriceWithTicketTypePrice:false,basePriceWithVisitorTypePrice:false,basePriceWithTicketAndVisitorPrice:false});
                resetAllDiscounts();
            }).catch((err) => {
                console.log('err>>>',err);
                toast.error(err.response?.data?.message || "An error occurred");
                setErrors(err.response?.data || {});
            });
        }
    };
    return (
        <Row>
            <Col md={4}>
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-primary text-white">
                        <h6 className="mb-0">Add Ticket Price</h6>
                    </CardHeader>
                    <CardBody>
                        <FormGroup>
                            <Label className="fw-bold">Ticket Type</Label>
                            <Input type="select" name="ticketType" value={ticketTypePrice.ticketType} onChange={ticketTypeHandler}>
                                <option value="">Select Ticket Type</option>
                                {TicketTypeList.map(item => <option key={item.id} value={item.id}>{item.ticket_type}</option>)}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label className="d-flex align-items-center">
                                <Input type="checkbox" 
                                checked={isVisitor.ticketTypeWithVisitor === true} 
                                onChange={(e) => {
                                        setIsVisitor((prev)=>({
                                            ...prev,
                                            ticketTypeWithVisitor: e.target.checked ? true : false,
                                        }));
                                        if(!e.target.checked){
                                            setTicketTypePrice((prev)=>({
                                                ...prev,
                                                visitorId:"",
                                                subVisitorId:"",
                                                subSubVisitorId:""
                                            }));
                                        }
                                    } 
                                }
                                className="me-2" />
                                Price according to Visitor Categories
                            </Label>
                        </FormGroup>
                        <DiscountFields
                            enableDiscount={discountState.ticketType.enableDiscount}
                            discountType={discountState.ticketType.discountType}
                            discountValue={discountState.ticketType.discountValue}
                            onChange={(updates) => updateDiscount("ticketType", updates)}
                        />
                        {(isVisitor.ticketTypeWithVisitor === true && (
                            <>
                            <FormGroup>
                                <Label className="fw-bold">Visitor Type</Label>
                                <Input type="select" name="visitorId" value={ticketTypePrice.visitorId} onChange={ticketTypeHandler}>
                                    <option value="">Select Visitor Type</option>
                                    {TouristTypeList.map(item => <option key={item.id} value={item.id}>{item.visitor_type}</option>)}
                                </Input>
                            </FormGroup>
                            {(visitorSubTypeListByType?.length > 0 && (
                                <>
                                <FormGroup>
                                    <Label className="fw-bold">Sub Visitor</Label>
                                    <Input type="select" name="subVisitorId" value={ticketTypePrice.subVisitorId} onChange={ticketTypeHandler}>
                                        <option value="">Select Sub Visitor type</option>
                                        {visitorSubTypeListByType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_type}</option>)}
                                    </Input>
                                </FormGroup>
                                </>
                            ))}
                            {(visitorSubSubTypeListBySubType?.length > 0 && (
                                <>
                                <FormGroup>
                                    <Label className="fw-bold">Sub Sub Visitor</Label>
                                    <Input type="select" name="subSubVisitorId" value={ticketTypePrice.subSubVisitorId} onChange={ticketTypeHandler}>
                                        <option value="">Select Sub Sub Visitor Type</option>
                                        {visitorSubSubTypeListBySubType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_sub_type}</option>)}
                                    </Input>
                                </FormGroup>
                                </>
                            ))}
                            </>
                        ))}
                        <FormGroup>
                            <Label className="fw-bold">Price</Label>
                            <Input type="number" name="price" value={ticketTypePrice.price}  onChange={ticketTypeHandler} />
                        </FormGroup>
                        {errors?.ticket_type && <span className="text-danger">{errors.ticket_type}</span>}
                        {isEdit.ticketType ? (
                            <Button color="primary" onClick={() => handleSubmit('ticketType')}>Update</Button>
                        ) : (
                            <Button color="primary" onClick={() => handleSubmit('ticketType')}>Submit</Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-primary text-white">
                        <h6 className="mb-0">Add Sub Ticket Price</h6>
                    </CardHeader>
                    <CardBody>
                        <FormGroup>
                            <Label className="fw-bold">Ticket Sub Type</Label>
                            <Input type="select" name="ticketSubType" value={ticketSubTypePrice.ticketSubType} onChange={ticketSubTypeHandler} >
                                <option value="">Select Ticket Sub Type</option>
                                {TicketSubTypeList.map(item => <option key={item.id} value={item.id}>{item.sub_type}</option>)}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label className="d-flex align-items-center">
                                <Input type="checkbox" 
                                checked={isVisitor.ticketSubTypeWithVisitor === true} 
                                onChange={(e) => {
                                            setIsVisitor((prev)=>({
                                            ...prev,
                                            ticketSubTypeWithVisitor: e.target.checked ? true : false,
                                        }));
                                        if(!e.target.checked){
                                            setTicketSubTypePrice((prev)=>({
                                                ...prev,
                                                visitorId:"",
                                                subVisitorId:"",
                                                subSubVisitorId:""
                                            }));
                                        }
                                    } 
                                }
                                className="me-2" />
                                Price according to Visitor Categories
                            </Label>
                        </FormGroup>
                        <DiscountFields
                            enableDiscount={discountState.ticketSubType.enableDiscount}
                            discountType={discountState.ticketSubType.discountType}
                            discountValue={discountState.ticketSubType.discountValue}
                            onChange={(updates) => updateDiscount("ticketSubType", updates)}
                        />
                        {(isVisitor.ticketSubTypeWithVisitor === true && (
                            <>
                            <FormGroup>
                                <Label className="fw-bold">Visitor Type</Label>
                                <Input type="select" name="visitorId" value={ticketSubTypePrice.visitorId} onChange={ticketSubTypeHandler}>
                                    <option value="">Select Visitor Type</option>
                                    {TouristTypeList.map(item => <option key={item.id} value={item.id}>{item.visitor_type}</option>)}
                                </Input>
                            </FormGroup>
                            {(visitorSubTypeListByType?.length > 0 && (
                                <>
                                <FormGroup>
                                    <Label className="fw-bold">Sub Visitor</Label>
                                    <Input type="select" name="subVisitorId" value={ticketSubTypePrice.subVisitorId} onChange={ticketSubTypeHandler}>
                                        <option value="">Select Sub Visitor type</option>
                                        {visitorSubTypeListByType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_type}</option>)}
                                    </Input>
                                </FormGroup>
                                </>
                            ))}
                            {(visitorSubSubTypeListBySubType?.length > 0 && (
                                <>
                                <FormGroup>
                                    <Label className="fw-bold">Sub Sub Visitor</Label>
                                    <Input type="select" name="subSubVisitorId" value={ticketSubTypePrice.subSubVisitorId} onChange={ticketSubTypeHandler}>
                                        <option value="">Select Sub Sub Visitor Type</option>
                                        {visitorSubSubTypeListBySubType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_sub_type}</option>)}
                                    </Input>
                                </FormGroup>
                                </>
                            ))}
                            </>
                        ))}
                        <FormGroup>
                            <Label className="fw-bold">Price</Label>
                            <Input type="number" name="price" value={ticketSubTypePrice.price}  onChange={ticketSubTypeHandler} />
                        </FormGroup>
                        {errors?.ticket_type && <span className="text-danger">{errors.ticket_type}</span>}
                        {isEdit.ticketSubType ? (
                            <Button color="primary" onClick={() => handleSubmit('ticketSubType')}>Update</Button>
                        ) : (
                            <Button color="primary" onClick={() => handleSubmit('ticketSubType')}>Submit</Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-primary text-white">
                        <h6 className="mb-0">Add Sub Sub Ticket Price</h6>
                    </CardHeader>
                    <CardBody>
                        <FormGroup>
                            <Label className="fw-bold">Ticket Sub Sub Type</Label>
                            <Input type="select" name="ticketSubSubType" value={ticketSubSubTypePrice.ticketSubSubType} onChange={ticketSubSubTypeHandler} >
                                <option value="">Select Ticket Sub Sub Type</option>
                                {TicketSubSubTypeList.map(item => <option key={item.id} value={item.id}>{item.sub_sub_type}</option>)}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label className="d-flex align-items-center">
                                <Input type="checkbox" 
                                checked={isVisitor.ticketSubSubTypeWithVisitor === true} 
                                onChange={(e) => {
                                        setIsVisitor((prev)=>({
                                            ...prev,
                                            ticketSubSubTypeWithVisitor: e.target.checked ? true : false,
                                        }));
                                        if(!e.target.checked){
                                            setTicketSubSubTypePrice((prev)=>({
                                                ...prev,
                                                visitorId:"",
                                                subVisitorId:"",
                                                subSubVisitorId:""
                                            }));
                                        }
                                    }
                                } 
                                className="me-2" />
                                Price according to Visitor Categories
                            </Label>
                        </FormGroup>
                        <DiscountFields
                            enableDiscount={discountState.ticketSubSubType.enableDiscount}
                            discountType={discountState.ticketSubSubType.discountType}
                            discountValue={discountState.ticketSubSubType.discountValue}
                            onChange={(updates) => updateDiscount("ticketSubSubType", updates)}
                        />
                        {(isVisitor.ticketSubSubTypeWithVisitor === true && (
                            <>
                            <FormGroup>
                                <Label className="fw-bold">Visitor Type</Label>
                                <Input type="select" name="visitorId" value={ticketSubSubTypePrice.visitorId} onChange={ticketSubSubTypeHandler}>
                                    <option value="">Select Visitor Type</option>
                                    {TouristTypeList.map(item => <option key={item.id} value={item.id}>{item.visitor_type}</option>)}
                                </Input>
                            </FormGroup>
                            {(visitorSubTypeListByType?.length > 0 && (
                                <>
                                <FormGroup>
                                    <Label className="fw-bold">Sub Visitor</Label>
                                    <Input type="select" name="subVisitorId" value={ticketSubSubTypePrice.subVisitorId} onChange={ticketSubSubTypeHandler}>
                                        <option value="">Select Sub Visitor type</option>
                                        {visitorSubTypeListByType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_type}</option>)}
                                    </Input>
                                </FormGroup>
                                </>
                            ))}
                            {(visitorSubSubTypeListBySubType?.length > 0 && (
                                <>
                                <FormGroup>
                                    <Label className="fw-bold">Sub Sub Visitor</Label>
                                    <Input type="select" name="subSubVisitorId" value={ticketSubSubTypePrice.subSubVisitorId} onChange={ticketSubSubTypeHandler}>
                                        <option value="">Select Sub Sub Visitor Type</option>
                                        {visitorSubSubTypeListBySubType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_sub_type}</option>)}
                                    </Input>
                                </FormGroup>
                                </>
                            ))}
                            </>
                        ))}
                        <FormGroup>
                            <Label className="fw-bold">Price</Label>
                            <Input type="number" name="price" value={ticketSubSubTypePrice.price}  onChange={ticketSubSubTypeHandler} />
                        </FormGroup>
                        {errors?.ticket_type && <span className="text-danger">{errors.ticket_type}</span>}
                        {isEdit.ticketSubSubType ? (
                            <Button color="primary" onClick={() => handleSubmit('ticketSubSubType')}>Update</Button>
                        ) : (
                            <Button color="primary" onClick={() => handleSubmit('ticketSubSubType')}>Submit</Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Add Visitors Price</h6>
                    </CardHeader>
                    <CardBody>
                        <FormGroup>
                            <Label className="fw-bold">Visitor Price</Label>
                            <Input type="select" name="visitorId" value={visitorPrice.visitorId} onChange={visitorHandler}>
                                <option value="">Select Tourist Type</option>
                                {TouristTypeList.map(item => <option key={item.id} value={item.id}>{item.visitor_type}</option>)}
                            </Input>
                        </FormGroup>
                        <DiscountFields
                            enableDiscount={discountState.visitorPrice.enableDiscount}
                            discountType={discountState.visitorPrice.discountType}
                            discountValue={discountState.visitorPrice.discountValue}
                            onChange={(updates) => updateDiscount("visitorPrice", updates)}
                        />
                        <FormGroup>
                            <Label className="fw-bold">Price</Label>
                            <Input type="number" name="visitorPrice" value={visitorPrice.visitorPrice}  onChange={visitorHandler} />
                        </FormGroup>
                        {errors?.visitorPrice && <span className="text-danger">{errors.visitorPrice}</span>}
                        {isEdit.visitorPrice ? (
                            <Button color="primary" onClick={() => handleSubmit('visitorPrice')}>Update</Button>
                        ) : (
                            <Button color="primary" onClick={() => handleSubmit('visitorPrice')}>Submit</Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Add Sub Visitors Price</h6>
                    </CardHeader>
                    <CardBody>
                        <FormGroup>
                            <Label className="fw-bold">Sub Visitor Price</Label>
                            <Input type="select" name="subVisitorId" value={visitorPrice.subVisitorId} onChange={visitorHandler}>
                                <option value="">Select Tourist Type</option>
                                {visitorSubTypeListByType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_type}</option>)}
                            </Input>
                        </FormGroup>
                        <DiscountFields
                            enableDiscount={discountState.subVisitorPrice.enableDiscount}
                            discountType={discountState.subVisitorPrice.discountType}
                            discountValue={discountState.subVisitorPrice.discountValue}
                            onChange={(updates) => updateDiscount("subVisitorPrice", updates)}
                        />
                        <FormGroup>
                            <Label className="fw-bold">Price</Label>
                            <Input type="number" name="subVisitorPrice" value={visitorPrice.subVisitorPrice}  onChange={visitorHandler} />
                        </FormGroup>
                        {errors?.subVisitorPrice && <span className="text-danger">{errors.subVisitorPrice}</span>}
                        {isEdit.subVisitorPrice ? (
                            <Button color="primary" onClick={() => handleSubmit('subVisitorPrice')}>Update</Button>
                        ) : (
                            <Button color="primary" onClick={() => handleSubmit('subVisitorPrice')}>Submit</Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Add Sub Sub Visitors Price</h6>
                    </CardHeader>
                    <CardBody>
                        <FormGroup>
                            <Label className="fw-bold">Sub Sub Visitor Price</Label>
                            <Input type="select" name="subSubVisitorId" value={visitorPrice.subSubVisitorId} onChange={visitorHandler}>
                                <option value="">Select Tourist Type</option>
                                {visitorSubSubTypeListBySubType.map(item => <option key={item.id} value={item.id}>{item.visitor_sub_sub_type}</option>)}
                            </Input>
                        </FormGroup>
                        <DiscountFields
                            enableDiscount={discountState.subSubVisitorPrice.enableDiscount}
                            discountType={discountState.subSubVisitorPrice.discountType}
                            discountValue={discountState.subSubVisitorPrice.discountValue}
                            onChange={(updates) => updateDiscount("subSubVisitorPrice", updates)}
                        />
                        <FormGroup>
                            <Label className="fw-bold">Price</Label>
                            <Input type="number" name="subSubVisitorPrice" value={visitorPrice.subSubVisitorPrice}  onChange={visitorHandler} />
                        </FormGroup>
                        {errors?.subSubVisitorPrice && <span className="text-danger">{errors.subSubVisitorPrice}</span>}
                        {isEdit.subSubVisitorPrice ? (
                            <Button color="primary" onClick={() => handleSubmit('subSubVisitorPrice')}>Update</Button>
                        ) : (
                            <Button color="primary" onClick={() => handleSubmit('subSubVisitorPrice')}>Submit</Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
            <Col md={12}>
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Other Price</h6>
                    </CardHeader>
                    <CardBody>
                        <div className="col-md-12">
                            <h6 className="fw-bold text-secondary">Additional Services</h6>
                            <Button color="success" size="sm" className="mb-2" onClick={addService}>
                                <MdAdd size={18} /> Add Service
                            </Button>
                        </div>
                        {services.map((service, index) => (
                            <div key={index} className="d-flex align-items-center gap-2 mb-2">
                                <Input type="text" name="service_name" placeholder="Service Name" value={service.service_name} onChange={(e) => inputServiceHandler(e, index)} className="flex-grow-1" />
                                <Input type="number" name="service_price" placeholder="Price" value={service.service_price} onChange={(e) => inputServiceHandler(e, index)} className="flex-grow-1" />
                                {service?.id !='' ? (
                                    <Button color="danger" size="sm" onClick={() => handleServiceDel(service?.serviceId)}>
                                        <AiOutlineDelete
                                            size={22}
                                            className="text-white"
                                        />
                                    </Button>
                                ):(
                                    <Button color="danger" size="sm" onClick={() => removeService(index)}>
                                        <MdRemove size={18} />
                                    </Button>
                                )}
                            </div>
                        ))}
                        <div className="row">
                          <div className="col-md-4">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" 
                                    checked={formData.onlyBasePrice === true} 
                                    onChange={(e) => {
                                            setFormData((prev)=>({
                                                ...prev,
                                                onlyBasePrice: e.target.checked ? true : false,
                                                onlyTicketTypePrice:false,
                                                onlyVisitorTypePrice:false,
                                                basePriceWithTicketTypePrice:false,
                                                basePriceWithVisitorTypePrice:false,
                                                basePriceWithTicketAndVisitorPrice:false
                                            }));
                                            
                                        } 
                                    }
                                    className="me-2" />
                                    Show Only Base Price
                                </Label>
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" 
                                    checked={formData.onlyTicketTypePrice === true}
                                    onChange={(e) => {
                                            setFormData((prev)=>({
                                                ...prev,
                                                onlyTicketTypePrice: e.target.checked ? true : false,
                                                onlyBasePrice:false,
                                                onlyVisitorTypePrice:false,
                                                basePriceWithTicketTypePrice:false,
                                                basePriceWithVisitorTypePrice:false,
                                                basePriceWithTicketAndVisitorPrice:false
                                            }));
                                        } 
                                    }
                                    className="me-2" />
                                    Show Only Ticket type
                                </Label>
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" 
                                    checked={formData.onlyVisitorTypePrice === true}
                                    onChange={(e) => {
                                            setFormData((prev)=>({
                                                ...prev,
                                                onlyVisitorTypePrice: e.target.checked ? true : false,
                                                onlyBasePrice:false,
                                                onlyTicketTypePrice:false,
                                                basePriceWithTicketTypePrice:false,
                                                basePriceWithVisitorTypePrice:false,
                                                basePriceWithTicketAndVisitorPrice:false
                                            }));
                                        } 
                                    }
                                    className="me-2" />
                                    Show Only Visitors type
                                </Label>
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" 
                                    checked={formData.basePriceWithTicketTypePrice === true}
                                    onChange={(e) => {
                                            setFormData((prev)=>({
                                                ...prev,
                                                basePriceWithTicketTypePrice: e.target.checked ? true : false,
                                                onlyBasePrice:false,
                                                onlyTicketTypePrice:false,
                                                onlyVisitorTypePrice:false,
                                                basePriceWithVisitorTypePrice:false,
                                                basePriceWithTicketAndVisitorPrice:false
                                            }));
                                        } 
                                    }
                                    className="me-2" />
                                    Show Base Price with Ticket Type price
                                </Label>
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" 
                                    checked={formData.basePriceWithVisitorTypePrice === true}
                                    onChange={(e) => {
                                            setFormData((prev)=>({
                                                ...prev,
                                                basePriceWithVisitorTypePrice: e.target.checked ? true : false,
                                                onlyBasePrice:false,
                                                onlyTicketTypePrice:false,
                                                onlyVisitorTypePrice:false,
                                                basePriceWithTicketTypePrice:false,
                                                basePriceWithTicketAndVisitorPrice:false
                                            }));
                                        } 
                                    }
                                    className="me-2" />
                                    Show Base Price with Visitors Type Price
                                </Label>
                            </FormGroup>
                        </div>
                        <div className="col-md-4">
                            <FormGroup>
                                <Label className="d-flex align-items-center">
                                    <Input type="checkbox" 
                                    checked={formData.basePriceWithTicketAndVisitorPrice === true}
                                    onChange={(e) => {
                                            setFormData((prev)=>({
                                                ...prev,
                                                basePriceWithTicketAndVisitorPrice: e.target.checked ? true : false,
                                                onlyBasePrice:false,
                                                onlyTicketTypePrice:false,
                                                onlyVisitorTypePrice:false,
                                                basePriceWithTicketTypePrice:false,
                                                basePriceWithVisitorTypePrice:false,
                                            }));
                                        } 
                                    }
                                    className="me-2" />
                                    Show Base Price with Visitors Type And Ticket Type price
                                </Label>
                            </FormGroup>
                        </div>
                            <div className="col-md-4">
                                <FormGroup>
                                    <Label className="fw-bold">Base Price</Label>
                                    <Input type="number" name="basePrice" value={basePrice?.price}  onChange={(e) => setBasePrice((prev) => ({...prev,price:e.target.value}))} />
                                </FormGroup>
                            </div>
                        </div>
                        {errors?.basePrice && <span className="text-danger">{errors.basePrice}</span>}
                        {isEdit.basePrice ? (
                            <Button color="primary" onClick={() => handleSubmit('basePrice')}>Update</Button>
                        ) : (
                            <Button color="primary" onClick={() => handleSubmit('basePrice')}>Submit</Button>
                        )}
                    </CardBody>
                </Card>
            </Col>
            <AdditionalFormFields addFormType={'ticketPrice'} placeId={placeId}/>
            <Col md={12} className="mt-3">
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Ticket Type Price</h6>
                    </CardHeader>
                    <CardBody>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Ticket type</th>
                                    <th>Visitor type</th>
                                    <th>Sub Visitor type</th>
                                    <th>Sub Sub Visitor type</th>
                                    <th>Price</th>
                                    <th>Discount Status</th>
                                    <th>Discount Type</th>
                                    <th>Discount Value</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                            {ticketPrices?.filter(item => item?.type === "ticketType").map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item?.ticketType?.ticket_type ?? "N/A"}</td>
                                    <td>{item?.visitorType?.visitor_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubType?.visitor_sub_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubSubType?.visitor_sub_sub_type ?? "N/A"}</td>
                                    <td><b>{item?.price ?? 0.00}</b></td>
                                    <td>{getDiscountStatusLabel(item?.isdiscount)}</td>
                                    <td>{item?.discountType ?? "N/A"}</td>
                                    <td>{item?.discountValue ?? "N/A"}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    setTicketTypePrice(prev => ({
                                                        ...prev,
                                                        id: item?.id ?? "",
                                                        price: item?.price ?? "",
                                                        ticketType: item?.ticket_type_id  ,
                                                        visitorId: item?.tourist_type_id ?? "",
                                                        subVisitorId: item?.tourist_sub_type_id ?? "",
                                                        subSubVisitorId: item?.tourist_sub_sub_type_id ?? "",
                                                    }));
                                                    updateDiscount("ticketType", mapDiscountFromItem(item));
                                                
                                                    if (item?.tourist_type_id) {
                                                        setIsVisitor(prev => ({
                                                            ...prev,
                                                            ticketTypeWithVisitor: true
                                                        }));
                                                        dispatch(getVisitorSubTypeByType(auth.token, item.tourist_type_id));
                                                    }else{
                                                        setIsVisitor(prev => ({
                                                            ...prev,
                                                            ticketTypeWithVisitor: false
                                                        })); 
                                                    }
                                                
                                                    if (item?.tourist_sub_type_id) {
                                                        dispatch(getVisitorSubSubTypeBySubType(auth.token, item.tourist_sub_type_id));
                                                    }
                                                
                                                    setIsEdit(prev => ({
                                                        ...prev,
                                                        ticketType: true
                                                    }));
                                                }}
                                                
                                                />
                                            <AiOutlineDelete
                                                size={22}
                                                className="text-danger"
                                                onClick={() => handleTicketPriceDel(item.id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
            <Col md={12} className="mt-3">
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Ticket Sub Type Price</h6>
                    </CardHeader>
                    <CardBody>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Ticket Sub type</th>
                                    <th>Visitor type</th>
                                    <th>Sub Visitor type</th>
                                    <th>Sub Sub Visitor type</th>
                                    <th>Price</th>
                                    <th>Discount Status</th>
                                    <th>Discount Type</th>
                                    <th>Discount Value</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                            {ticketPrices?.filter(item => item?.type === "ticketSubType").map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item?.ticketSubType?.sub_type ?? "N/A"}</td>
                                    <td>{item?.visitorType?.visitor_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubType?.visitor_sub_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubSubType?.visitor_sub_sub_type ?? "N/A"}</td>
                                    <td><b>{item?.price ?? 0.00}</b></td>
                                    <td>{getDiscountStatusLabel(item?.isdiscount)}</td>
                                    <td>{item?.discountType ?? "N/A"}</td>
                                    <td>{item?.discountValue ?? "N/A"}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    if(item?.ticket_type_id){
                                                        dispatch(getTicketSubType(auth.token, item?.ticket_type_id));
                                                    }
                                                    setTicketSubTypePrice(prev => ({
                                                        ...prev,
                                                        id: item?.id ?? "",
                                                        price: item?.price ?? "",
                                                        ticketType: item?.ticket_type_id ?? "",
                                                        ticketSubType: item?.ticket_sub_type_id ?? "",
                                                        visitorId: item?.tourist_type_id ?? "",
                                                        subVisitorId: item?.tourist_sub_type_id ?? "",
                                                        subSubVisitorId: item?.tourist_sub_sub_type_id ?? "",
                                                    }));
                                                    updateDiscount("ticketSubType", mapDiscountFromItem(item));
                                                
                                                    if (item?.tourist_type_id) {
                                                        setIsVisitor(prev => ({
                                                            ...prev,
                                                            ticketSubTypeWithVisitor: true
                                                        }));
                                                        dispatch(getVisitorSubTypeByType(auth.token, item.tourist_type_id));
                                                    }else{
                                                        setIsVisitor(prev => ({
                                                            ...prev,
                                                            ticketSubTypeWithVisitor: false
                                                        })); 
                                                    }
                                                
                                                    if (item?.tourist_sub_type_id) {
                                                        dispatch(getVisitorSubSubTypeBySubType(auth.token, item.tourist_sub_type_id));
                                                    }
                                                
                                                    setIsEdit(prev => ({
                                                        ...prev,
                                                        ticketSubType: true
                                                    }));
                                                }}
                                                />
                                            <AiOutlineDelete
                                                size={22}
                                                className="text-danger"
                                                onClick={() => handleTicketPriceDel(item.id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
            <Col md={12} className="mt-3">
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Ticket Sub Sub Type Price</h6>
                    </CardHeader>
                    <CardBody>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Ticket Sub Sub type</th>
                                    <th>Visitor type</th>
                                    <th>Sub Visitor type</th>
                                    <th>Sub Sub Visitor type</th>
                                    <th>Price</th>
                                    <th>Discount Status</th>
                                    <th>Discount Type</th>
                                    <th>Discount Value</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                            {ticketPrices?.filter(item => item?.type === "ticketSubSubType").map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item?.ticketSubSubType?.sub_sub_type ?? "N/A"}</td>
                                    <td>{item?.visitorType?.visitor_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubType?.visitor_sub_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubSubType?.visitor_sub_sub_type ?? "N/A"}</td>
                                    <td><b>{item?.price ?? 0.00}</b></td>
                                    <td>{getDiscountStatusLabel(item?.isdiscount)}</td>
                                    <td>{item?.discountType ?? "N/A"}</td>
                                    <td>{item?.discountValue ?? "N/A"}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    if(item?.ticket_sub_type_id){
                                                        dispatch(getTicketSubSubType(auth.token, item?.ticket_sub_type_id));
                                                    }
                                                    setTicketSubSubTypePrice(prev => ({
                                                        ...prev,
                                                        id: item?.id ?? "",
                                                        price: item?.price ?? "",
                                                        ticketSubSubType: item?.ticket_sub_sub_type_id ?? ""  ,
                                                        visitorId: item?.tourist_type_id ?? "",
                                                        subVisitorId: item?.tourist_sub_type_id ?? "",
                                                        subSubVisitorId: item?.tourist_sub_sub_type_id ?? "",
                                                    }));
                                                    updateDiscount("ticketSubSubType", mapDiscountFromItem(item));
                                                
                                                    if (item?.tourist_type_id) {
                                                        setIsVisitor(prev => ({
                                                            ...prev,
                                                            ticketSubSubTypeWithVisitor: true
                                                        }));
                                                        dispatch(getVisitorSubTypeByType(auth.token, item.tourist_type_id));
                                                    }else{
                                                        setIsVisitor(prev => ({
                                                            ...prev,
                                                            ticketSubSubTypeWithVisitor: false
                                                        })); 
                                                    }
                                                
                                                    if (item?.tourist_sub_type_id) {
                                                        dispatch(getVisitorSubSubTypeBySubType(auth.token, item.tourist_sub_type_id));
                                                    }
                                                
                                                    setIsEdit(prev => ({
                                                        ...prev,
                                                        ticketSubSubType: true
                                                    }));
                                                }}
                                                />
                                            <AiOutlineDelete
                                                size={22}
                                                className="text-danger"
                                                onClick={() => handleTicketPriceDel(item.id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
            <Col md={6} className="mt-3">
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Visitor type Price</h6>
                    </CardHeader>
                    <CardBody>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Visitor type</th>
                                    <th>Price</th>
                                    <th>Discount Status</th>
                                    <th>Discount Type</th>
                                    <th>Discount Value</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                            {ticketPrices?.filter(item => item?.type === "visitorPrice").map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item?.visitorType?.visitor_type ?? "N/A"}</td>
                                    <td><b>{item?.price ?? 0.00}</b></td>
                                    <td>{getDiscountStatusLabel(item?.isdiscount)}</td>
                                    <td>{item?.discountType ?? "N/A"}</td>
                                    <td>{item?.discountValue ?? "N/A"}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    setVisitorPrice({
                                                        ...visitorPrice,
                                                        visitorPrice: item?.price,
                                                        visitorId: item?.tourist_type_id,
                                                        id: item?.id,
                                                    });
                                                    updateDiscount("visitorPrice", mapDiscountFromItem(item));
                                                    setIsEdit(prev =>({
                                                        ...prev,
                                                        visitorPrice:true
                                                    }));
                                                }}
                                                />
                                            <AiOutlineDelete
                                                size={22}
                                                className="text-danger"
                                                onClick={() => handleTicketPriceDel(item.id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
            <Col md={6} className="mt-3">
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Sub Visitor Price</h6>
                    </CardHeader>
                    <CardBody>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Visitor type</th>
                                    <th>Sub Visitor type</th>
                                    <th>Price</th>
                                    <th>Discount Status</th>
                                    <th>Discount Type</th>
                                    <th>Discount Value</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                            {ticketPrices?.filter(item => item?.type === "subVisitorPrice").map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item?.visitorType?.visitor_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubType?.visitor_sub_type ?? "N/A"}</td>
                                    <td><b>{item?.price ?? 0.00}</b></td>
                                    <td>{getDiscountStatusLabel(item?.isdiscount)}</td>
                                    <td>{item?.discountType ?? "N/A"}</td>
                                    <td>{item?.discountValue ?? "N/A"}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    if(item?.tourist_type_id){
                                                        dispatch(getVisitorSubTypeByType(auth.token, item?.tourist_type_id));
                                                    }
                                                    setVisitorPrice({
                                                        ...visitorPrice,
                                                        subVisitorPrice: item?.price,
                                                        subVisitorId: item?.tourist_sub_type_id,
                                                        id: item?.id,
                                                    });
                                                    updateDiscount("subVisitorPrice", mapDiscountFromItem(item));
                                                    setIsEdit(prev =>({
                                                        ...prev,
                                                        visitorSubPrice:true
                                                    }));
                                                }}
                                                />
                                            <AiOutlineDelete
                                                size={22}
                                                className="text-danger"
                                                onClick={() => handleTicketPriceDel(item.id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
            <Col md={12} className="mt-3">
                <Card className="mb-4 shadow-sm">
                    <CardHeader className="bg-secondary text-white">
                        <h6 className="mb-0">Sub Sub Visitor Price</h6>
                    </CardHeader>
                    <CardBody>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Visitor type</th>
                                    <th>Sub Visitor type</th>
                                    <th>Sub Sub Visitor type</th>
                                    <th>Price</th>
                                    <th>Discount Status</th>
                                    <th>Discount Type</th>
                                    <th>Discount Value</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                            {ticketPrices?.filter(item => item?.type === "subSubVisitorPrice").map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item?.visitorType?.visitor_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubType?.visitor_sub_type ?? "N/A"}</td>
                                    <td>{item?.visitorSubSubType?.visitor_sub_sub_type ?? "N/A"}</td>
                                    <td><b>{item?.price ?? 0.00}</b></td>
                                    <td>{getDiscountStatusLabel(item?.isdiscount)}</td>
                                    <td>{item?.discountType ?? "N/A"}</td>
                                    <td>{item?.discountValue ?? "N/A"}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    if(item?.tourist_sub_type_id){
                                                        dispatch(getVisitorSubSubTypeBySubType(auth.token, item?.tourist_sub_type_id));
                                                    }
                                                    setVisitorPrice({
                                                        ...visitorPrice,
                                                        subSubVisitorPrice: item?.price,
                                                        subSubVisitorId: item?.tourist_sub_sub_type_id,
                                                        id: item?.id,
                                                    });
                                                    updateDiscount("subSubVisitorPrice", mapDiscountFromItem(item));
                                                    setIsEdit(prev =>({
                                                        ...prev,
                                                        visitorSubSubPrice:true
                                                    }));
                                                }}
                                                />
                                            <AiOutlineDelete
                                                size={22}
                                                className="text-danger"
                                                onClick={() => handleTicketPriceDel(item.id)}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default PriceMaster;
